import ViewsTunnelService from "@/views/tunnel/ViewsTunnelService";

export default {
    routes: [{
        path: "/service/:service(.*)",
        name: "tunnel.service",
        component: ViewsTunnelService
    }]
}